import { Box } from "@mui/material";
import NumButton from "../atoms/NumButton";

const NumPadWrapper = ({ children }) => {
  return (
    <Box sx={{ margin: "24px 0 0 0", padding: "24px 0 0 0", display: "flex", flexDirection: "column", gap: 2 }}>
      {children}
    </Box>
  );
};

const Row = ({ children }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: 2 }}>
      {children}
    </Box>
  );
};

const EraseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <path d="m22.4 31.7 5.6-5.6 5.6 5.6 2.15-2.15L30.1 24l5.55-5.55-2.15-2.15-5.5 5.6-5.6-5.6-2.15 2.15L25.9 24l-5.65 5.55ZM6 24l8.45-11.95q.65-.9 1.55-1.475.9-.575 2-.575h21q1.25 0 2.125.875T42 13v22q0 1.25-.875 2.125T39 38H18q-1.1 0-2-.575-.9-.575-1.55-1.475Zm3.75 0 7.7 11H39V13H17.45ZM39 24V13v22Z" />
    </svg>
  );
};

const NumPad = ({ onClickButton }) => {
  return (
    <>
      <NumPadWrapper>
        <Row>
          <NumButton onClick={() => onClickButton("1")} variant="contained">
            1
          </NumButton>
          <NumButton onClick={() => onClickButton("2")} variant="contained">
            2
          </NumButton>
          <NumButton onClick={() => onClickButton("3")} variant="contained">
            3
          </NumButton>
        </Row>

        <Row>
          <NumButton onClick={() => onClickButton("4")} variant="contained">
            4
          </NumButton>
          <NumButton onClick={() => onClickButton("5")} variant="contained">
            5
          </NumButton>
          <NumButton onClick={() => onClickButton("6")} variant="contained">
            6
          </NumButton>
        </Row>

        <Row>
          <NumButton onClick={() => onClickButton("7")} variant="contained">
            7
          </NumButton>
          <NumButton onClick={() => onClickButton("8")} variant="contained">
            8
          </NumButton>
          <NumButton onClick={() => onClickButton("9")} variant="contained">
            9
          </NumButton>
        </Row>

        <Row>
          <Box sx={{ width: 88 }} />
          <NumButton onClick={() => onClickButton("0")} variant="contained">
            0
          </NumButton>
          <NumButton onClick={() => onClickButton("erase")} variant="text">
            <EraseIcon />
          </NumButton>
        </Row>
      </NumPadWrapper>
    </>
  );
};

export default NumPad;
